// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__fEwQq","col":"styles_col__1DMO1"};